export enum Size {
  auto = 'auto',
  tiny = 'tiny',
  small = 'small',
  normal = 'normal',
  large = 'large'
}
